import { Typography, Box, useTheme } from "@mui/material";
import React from "react";

interface MainPageTitleProps {
  children: React.ReactNode;
  subtitle?: string;
}

export function MainPageTitle({ children, subtitle }: MainPageTitleProps) {
  const theme = useTheme();
  return (
    <Box mb={5} mt={2} textAlign="center">
      <Typography
        variant="h3"
        fontWeight={900}
        color="primary.main"
        sx={{
          textShadow: '0 4px 16px rgba(80, 80, 80, 0.10)',
          letterSpacing: 1,
        }}
        gutterBottom
      >
        {children}
      </Typography>
      <Box
        sx={{
          width: 120,
          height: 8,
          borderRadius: 4,
          mx: "auto",
          background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
          boxShadow: '0 4px 16px rgba(80, 80, 80, 0.10)',
          opacity: 0.85,
        }}
        mb={subtitle ? 2 : 0}
      />
      {subtitle && (
        <Typography
          variant="h6"
          color="neutral600.main"
          fontWeight={400}
          sx={{ maxWidth: 700, mx: "auto" }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
} 